import React from "react";
import { useAuth } from "../../hooks/useAuth";
import styles from "./DashboardHome.module.css";

const DashboardHome = () => {
  const { user } = useAuth();

  return (
    <div className={styles.dashboardHome}>
      <h1 className={styles.welcomeTitle}>
        Welcome to ifillip admin panel
      </h1>

      {/* Optional: Stats Cards */}
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <div className={`${styles.statIcon} ${styles.iconPrimary}`}>
            <span>👥</span>
          </div>
          <div className={styles.statContent}>
            <h3>1,234</h3>
            <p>Total Users</p>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={`${styles.statIcon} ${styles.iconSuccess}`}>
            <span>🏫</span>
          </div>
          <div className={styles.statContent}>
            <h3>56</h3>
            <p>Schools</p>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={`${styles.statIcon} ${styles.iconWarning}`}>
            <span>📋</span>
          </div>
          <div className={styles.statContent}>
            <h3>89</h3>
            <p>Demo Requests</p>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={`${styles.statIcon} ${styles.iconInfo}`}>
            <span>📝</span>
          </div>
          <div className={styles.statContent}>
            <h3>342</h3>
            <p>Applications</p>
          </div>
        </div>
      </div>

      {/* Optional: Quick Actions */}
      <div className={styles.quickActions}>
        <h2 className={styles.sectionTitle}>Quick Actions</h2>
        <div className={styles.actionButtons}>
          <button className={styles.actionBtn}>Add New User</button>
          <button className={styles.actionBtn}>Create License</button>
          <button className={styles.actionBtn}>View Reports</button>
          <button className={styles.actionBtn}>Settings</button>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;
